import {createStyles, withStyles} from '@material-ui/core'
import Button from '@material-ui/core/Button/Button'
import { darken, lighten } from '@material-ui/core/styles'
import { siteColors } from '../Styles/SiteColors';

// There's a bug (https://github.com/mui-org/material-ui/issues/15827) that doesn't allow us to decorate
// our using WithStyles and ButtonProps to simplify this and so the workaround is to export the styles
// separately so we can use the base Button component (see MyInspectionAgreement.tsx "Sign" button)
// ideally we want to do something like this:
//      const greenButtonStyles = createStyles({})
//      type GreenButtonProps = ButtonProps & WithStyles<typeof greenButtonStyles>
//      export const GreenButton = withStyles(styleObject)<GreenButtonProps>(Button)
// but this does not work yet
export const blueButtonStyles = createStyles({
    root: {
        backgroundColor: siteColors.darkBlue,
        color: siteColors.white,
        '&:hover': {
            backgroundColor: darken(siteColors.darkBlue, 0.5)
        },
        '&:disabled': {
            backgroundColor: lighten(siteColors.darkBlue, 0.25),
            color: siteColors.gray,
            opacity: 0.90
        }
    }
});

export const BlueButton = withStyles(blueButtonStyles)(Button);
